import { useEffect } from "react";
import { useNavigate } from "react-router";
import { setCurrentNavigate } from "./app-navigate-helpers";

// Mounted once in the main app branch (src/index.tsx) - not needed in the
// standalone entries (login/mobile/branch/3ds-callback), since neither
// current caller (websocket, page-and-routing helpers) is reachable from
// those.
export function AppNavigateBridge() {
  const navigate = useNavigate();

  // Keep the latest `navigate` reference current on every render, with no
  // cleanup here that nulls it out. Under this app's plain (non-data)
  // `BrowserRouter`, useNavigate()'s identity changes on every location
  // change (its useCallback deps include the current pathname), so this
  // effect re-runs on every navigation. If its cleanup nulled the module
  // ref, there'd be a real window - between that cleanup and this effect's
  // own recreate in the same commit - where a descendant route's own
  // effect (e.g. cleanQueryParams() below) could call appNavigate() and
  // find no bridge installed, silently logging and no-op'ing a real
  // navigation attempt. See the separate unmount-only effect below for
  // the actual teardown.
  useEffect(() => {
    setCurrentNavigate(navigate);
  }, [navigate]);

  // Only clear on true unmount (the bridge itself leaving, e.g. an entry
  // branch tearing down) - the empty dependency array means this effect's
  // cleanup runs exactly once, not on every navigate() identity change
  // handled above.
  useEffect(() => {
    return () => {
      setCurrentNavigate(null);
    };
  }, []);

  return null;
}
